define("CCAW.CurrentYear.View", [
    "SCView",
    "ccaw_current_year.tpl",
], function (
    SCViewModule,
    ccaw_current_year_tpl
) {
    "use strict";

    var SCView = SCViewModule.SCView;

    function CCAWCurrentYearView(options) {
        SCView.call(this);

        this.options = options || {};
        this.template = ccaw_current_year_tpl;
    }

    CCAWCurrentYearView.prototype = Object.create(SCView.prototype);
    CCAWCurrentYearView.prototype.constructor = CCAWCurrentYearView;
    CCAWCurrentYearView.prototype.tagName = "span";
    CCAWCurrentYearView.prototype.className = "ccaw-current-year";

    CCAWCurrentYearView.prototype.getContext = function getContext() {
        return {
            currentYear: new Date().getFullYear(),
        };
    };

    return CCAWCurrentYearView;
});
